import { Box, Heading, Button } from 'theme-ui';

import { Svg } from '@snippets';
import { useFiltersSidebar } from '@hooks';

import { CurrentFilters } from '../CurrentFilters';
import { themed } from './MobileFilters.theme';

export const MobileFilters = themed(
  ({ theme, collection, collectionCategories, hasHero }) => {
    const [, { toggleFiltersSidebar }] = useFiltersSidebar();

    return (
      <Box data-comp={MobileFilters.displayName} sx={theme.wrapper}>
        {collectionCategories}

        <Box sx={theme.sticky}>
          <Button
            variant="buttons.plain"
            onClick={() =>
              toggleFiltersSidebar({
                label: 'Filter + Sort',
                isFiltersAndSort: true,
              })
            }
            sx={theme.button}
          >
            <Heading as="h5" sx={theme.title}>
              Filter + Sort
            </Heading>
          </Button>
        </Box>

        <CurrentFilters />
      </Box>
    );
  }
);

MobileFilters.displayName = 'MobileFilters';
